import { render } from "./PacienteList.vue?vue&type=template&id=aeffce52&scoped=true"
import script from "./PacienteList.vue?vue&type=script&lang=js"
export * from "./PacienteList.vue?vue&type=script&lang=js"

import "./PacienteList.vue?vue&type=style&index=0&id=aeffce52&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeffce52"]])

export default __exports__